<span matSnackBarLabel>
  Está disponível uma nova versão da aplicação
</span>
<span matSnackBarActions>
  <button mat-button matSnackBarAction (click)="skip()">Ignorar</button>
  <button mat-button matSnackBarAction (click)="update()">Actualizar</button>
</span>